/**
 * AgentEnquiryHead
 * 
 * @Author: Focci
 * @Date: 2024-01-17 10:29:22
 * @Last Modified by: Focci
 * @Last Modified time: 2024-01-17 10:29:22
 */

import PropTypes from 'prop-types'
import Image from 'next/image'
import { IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { imageSize } from '@lib/image/loader'

export default function AgentEnquiryHead({
  officeColor = '#9e9e9e',
  officeIcon = '',
  fontColor = '#fff',
  onClick = () => {}
}) {
  return (
    <div
      className="h-12 flex items-center justify-between pl-4 pr-2"
      style={{ backgroundColor: officeColor }}
    >
      <div className="md:hidden ml-auto" />
      <div>
        {officeIcon && (
          <Image 
            src={imageSize(officeIcon, 160) || ''}
            width={160}
            height={50}
            alt="officeIcon"
            className="object-contain object-right md:object-left max-h-[2rem]"
          />
        )}
      </div>
      <div>
        <IconButton onClick={onClick}>
          <CloseIcon style={{ color: fontColor }} />
        </IconButton>
      </div>
    </div>
  )
}

AgentEnquiryHead.propTypes = {
  officeColor: PropTypes.string,
  officeIcon: PropTypes.string,
  onClick: PropTypes.func,
}
